import { render, staticRenderFns } from "./WatermarkDetection.vue?vue&type=template&id=8d4f43ba"
import script from "./WatermarkDetection.vue?vue&type=script&lang=js"
export * from "./WatermarkDetection.vue?vue&type=script&lang=js"
import style0 from "./WatermarkDetection.vue?vue&type=style&index=0&id=8d4f43ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports